import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PrivateRoute } from "../private-route";
import { AuthSectionLayout } from "../../pages/auth-section";
import { AutoRedirectToModule } from "../../pages/private-section/auto-redirect";
import { LoginPage } from "../../pages/auth-section/login-page/LoginPage";
import {
  RequestNewPasswordForm,
  PasswordRecoveryLayout,
  ValidateCodeForm,
  CreateNewPasswordForm,
} from "../../pages/auth-section/password-recovery";
import {
  GeoVelesLayout,
  PaginaInicial,
  ListaProjetos,
  FormCreateProjeto,
  FormDuplicateProjeto,
  FormEditProjeto,
  DetalhesDoProjeto,
  RecortesDoProjeto,
  ExtracaoPadrao,
  ExtracoesList,
  LayoutExtracao,
  CreateLayoutRecorteExtracao,
  EditLayoutRecorteExtracao
} from "../../pages/private-section/geo-veles";

import { ModalContainer } from "../../modal-container";
export const MainRouter = () => {
  return (
    <>
      <ModalContainer />
      <Routes>
        <Route path="/" element={
          <PrivateRoute>
            <AutoRedirectToModule />
          </PrivateRoute>
        } />
        <Route path="geo-veles" element={<GeoVelesLayout />}>
          <Route
            path=""
            element={
              <>
                <PrivateRoute>
                  <PaginaInicial />
                </PrivateRoute>
              </>
            }
          />
          <Route
            path="projetos"
            element={
              <PrivateRoute>
                <ListaProjetos />
              </PrivateRoute>
            }
          />
          <Route
            path="projetos/criar"
            element={
              <PrivateRoute>
                <FormCreateProjeto />
              </PrivateRoute>
            }
          />

          <Route
            path="projetos/:id"
            element={
              <PrivateRoute>
                <DetalhesDoProjeto />
              </PrivateRoute>
            }
          />
          <Route
            path="projetos/:id/recorte"
            element={
              <PrivateRoute>
                <RecortesDoProjeto />
              </PrivateRoute>
            }
          />
          <Route
            path="projetos/:id/extracao"
            element={
              <PrivateRoute>
                <ExtracaoPadrao />
              </PrivateRoute>
            }
          />
          <Route
            path="extracoes"
            element={
              <PrivateRoute>
                <ExtracoesList />
              </PrivateRoute>
            }
          />
          <Route
            path="extracoes/download"
            element={
              <PrivateRoute>
                <LayoutExtracao />
              </PrivateRoute>
            }
          />
          <Route
            path="projetos/duplicate"
            element={
              <PrivateRoute>
                <FormDuplicateProjeto />
              </PrivateRoute>
            }
          />
          <Route
            path="projetos/:id/recorte/createlayoutRecorteExtracao"
            element={
              <PrivateRoute>
                <CreateLayoutRecorteExtracao />
              </PrivateRoute>
            }
          />

          <Route
            path="projetos/:idLayout/recorte/editlayoutRecorteExtracao"
            element={
              <PrivateRoute>
                <EditLayoutRecorteExtracao />
              </PrivateRoute>
            }
          />
        </Route>
        <Route path="auth/login" element={<LoginPage />} />
        <Route path="auth" element={<AuthSectionLayout />}>
          <Route
            path="password-recovery"
            element={<PasswordRecoveryLayout />}
          >
            <Route
              path="request-new-password"
              element={<RequestNewPasswordForm />}
            />
            <Route path="validate-code" element={<ValidateCodeForm />} />
            <Route
              path="create-new-password"
              element={<CreateNewPasswordForm />}
            />
          </Route>
        </Route>
      </Routes>
    </>
  );
};  
